import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import ReactFlagsSelect from "react-flags-select";
import { useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import Select from "react-select";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { checkImageValidation } from "../../Utils/Common";


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Add_user = props => {
  //meta title
  document.title = 'Add User';
  const history = useHistory();
  const { getRequest, postRequest, postRequestByFormData } = useRequests();
  const [formData, setFormData] = useState({
    avatar:'',
    first_name: '',
    last_name: '',
    email: '',
    city:'',
    state:'',
    phone: '',
    country_code: 'ES',
    country: {label: 'Spain', value: 'Spain'},
    dob:'',
    gender:{label: 'Select Gender', value: ''},
  });

  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  const [File, setFile] = useState();
  const [FileName, setFileName] = useState('');
  const saveFile = (e) => {
          if ((e.target.files).length > 0) {
              setFile(e.target.files[0]);
              setFileName(e.target.files[0].name);
  
              var validationRes = checkImageValidation(e.target.files[0]);
              if (!validationRes.status) {
                  setFile();
                  setFileName('');
                  setAlertData((AlertData) => ({
                      ...AlertData,
                      variant: 'error',
                      message: validationRes.msg,
                  }));
                  resetAlertData();
                  return false;
              }
          }
      };

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: formData,
    validationSchema: Yup.object({
      
      first_name: Yup.string().required('First Name is required'),
      last_name: Yup.string().required('Last Name is required'),
      email: Yup.string().email('Please enter a valid email!').max(255)
        .required('Email is required'),
      phone: Yup.string().matches(/^[#0-9]+$/,'Please enter a valid mobile number!')
        .required('Mobile Number is required')
        .test(
          'len',
          'Mobile numbers should not be greater than 10 digits!',
          function (value) {
              return value ? value.length <= 10 : false; // Ensure the number is not greater than 10 digits
          }
      ),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('City is required'),
      country_code: Yup.string().required('Please select country code'),
      country: Yup.object().shape({
          label: Yup.string().required('Please select a country'),
          value: Yup.string().required('Please select a country'),
        }).required('Please select a country'),
      dob: Yup.date()
      .required("Date of Birth is required")
      .max(new Date(), "Date of Birth cannot be in the future"),
      gender: Yup.object().shape({
        label: Yup.string().required('Please select a gender'),
        value: Yup.string().required('Please select a gender'),
      }).required('Please select a gender'),

    }),
    onSubmit: async (values) => {
      try {
        let temp_country_code = AllCountriesCustomData.find(element => element.code === values.country_code);

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        // Create FormData to send both file and other data
        const formData = new FormData();
        formData.append("avatar", File);
        formData.append("first_name",values.first_name);
        formData.append("last_name",values.last_name);
        formData.append("email",values.email);
        formData.append("city",values.city);
        formData.append("state",values.state);
        formData.append("country",values.country.value);
        formData.append("country_code",temp_country_code.phone_code);
        formData.append("phone",values.phone);
        formData.append("dob",values.dob);
        formData.append("gender",values.gender.value);
       
        
        const res = await postRequestByFormData('add-user', formData);
        if (res && res.code === 200) {
          setFormData({
            avatar:'',
            first_name: '',
            last_name: '',
            email: '',
            city:'',
            state:'',
            phone: '',
            country_code: 'ES',
            country: {label: 'Spain', value: 'Spain'},
            dob:'',
            gender:{label: 'Select Gender', value: ''},
          });
          history.push({
            pathname: '/user_management',
            state: { code: 200, status: 'success', message: res.message }
          });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Submit';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);

      tempArr = [];
      originalText.forEach(element => {
        let temp = {
            code: element.country_code,
            label: element.country_code + ' +' + element.phone_code,
            phone_code: element.phone_code,
        };
        tempArr.push(temp);
      });
      setAllCountriesCustomData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetAllCountries();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Eshepay")} breadcrumbItem={props.t("Add User")} />

          <Card>
            <CardBody>
              <Row>
              
              <Col md={6} xs="12">
                  <div className="mb-3">
                  <Label className="form-label">Profile Picture :</Label>
                    <Input
                      className="fileUpload" 
                      name="avatar" 
                      type="file"                      
                      onChange={saveFile}
                      id="formFile"                 
                    />
                    <p style={{color: 'black', marginTop: '0.5rem'}}>
                                        Only PNG, JPEG, JPG files allowed.
                                    </p>
                    {validation1.touched.avatar && validation1.errors.avatar ? (
                      <FormFeedback type="invalid">{validation1.errors.avatar}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
             
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">First name :</Label>
                    <Input 
                      name="first_name" 
                      type="text" 
                      placeholder={'Enter first name'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.first_name || ""}
                      invalid={
                        validation1.touched.first_name && validation1.errors.first_name ? true : false
                      }
                    />
                    {validation1.touched.first_name && validation1.errors.first_name ? (
                      <FormFeedback type="invalid">{validation1.errors.first_name}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Last name :</Label>
                    <Input
                      name="last_name" 
                      type="text" 
                      placeholder={'Enter last name'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.last_name || ""}
                      invalid={
                        validation1.touched.last_name && validation1.errors.last_name ? true : false
                      }
                    />
                    {validation1.touched.last_name && validation1.errors.last_name ? (
                      <FormFeedback type="invalid">{validation1.errors.last_name}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Email :</Label>
                    <Input
                      name="email" 
                      type="email" 
                      placeholder={'Enter email'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.email || ""}
                      invalid={
                        validation1.touched.email && validation1.errors.email ? true : false
                      }
                    />
                    {validation1.touched.email && validation1.errors.email ? (
                      <FormFeedback type="invalid">{validation1.errors.email}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">City :</Label>
                    <Input
                      name="city" 
                      type="city" 
                      placeholder={'Enter city'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.city || ""}
                      invalid={
                        validation1.touched.city && validation1.errors.city ? true : false
                      }
                    />
                    {validation1.touched.city && validation1.errors.city ? (
                      <FormFeedback type="invalid">{validation1.errors.city}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">State :</Label>
                    <Input
                      name="state" 
                      type="state" 
                      placeholder={'Enter state'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.state || ""}
                      invalid={
                        validation1.touched.state && validation1.errors.state ? true : false
                      }
                    />
                    {validation1.touched.state && validation1.errors.state ? (
                      <FormFeedback type="invalid">{validation1.errors.state}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3 Register-Select2">
                    <Label className="form-label">Select country :</Label>
                    <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                    {validation1.touched.country && validation1.errors.country ? (
                      <FormFeedback type="invalid">{validation1.errors.country}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                
                <Col md={6} xs={12}>
                  <div className="mb-3 signupCountry">
                    <Label>Mobile no. :</Label>
                    <ReactFlagsSelect
                      placeholder={'Select country code'}
                      countries={AllCountriesCustomData.map(country => country.code)}
                      customLabels={AllCountriesCustomData.reduce((acc, country) => {
                        acc[country.code] = country.label;
                        return acc;
                      }, {})}
                      name="country_code" selected={validation1.values.country_code} onSelect={(e) => validation1.setValues({ ...validation1.values, country_code: e })}
                    />
                    <Input
                      name="phone"
                      type="text" 
                      placeholder={'Enter mobile number'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.phone || ""}
                      invalid={
                        validation1.touched.phone && validation1.errors.phone ? true : false
                      }
                    />
                    {validation1.touched.country_code && validation1.errors.country_code ? (
                      <FormFeedback type="invalid" >{validation1.errors.country_code}</FormFeedback>
                    ) : null}
                    {validation1.touched.phone && validation1.errors.phone ? (
                      <FormFeedback type="invalid" className="space_mobile_number">{validation1.errors.phone}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Date of Birth :</Label>
                    <Input 
                      name="dob" 
                      type="date" 
                      placeholder="Select date of birth"
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.dob || ""}
                      invalid={
                        validation1.touched.dob && validation1.errors.dob ? true : false
                      }
                    />
                    {validation1.touched.dob && validation1.errors.dob ? (
                      <FormFeedback type="invalid">{validation1.errors.dob}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3 Register-Select2">
                    <Label className="form-label">Select Gender :</Label>
                    <Select
                      styles={colourStyles}
                      name="gender"
                      value={validation1.values.gender}
                      onChange={(selectedOption) =>
                        validation1.setFieldValue("gender", selectedOption)
                      }
                      onBlur={() => validation1.setFieldTouched("gender", true)}
                      options={[
                        { value: "male", label: "Male" },
                        { value: "female", label: "Female" },
                      ]}
                      classNamePrefix="select2-selection"
                    />
                    {validation1.touched.gender && validation1.errors.gender ? (
                      <FormFeedback type="invalid">{validation1.errors.gender}</FormFeedback>
                    ) : null}
                  </div>
                </Col>

                <div className="text-left mt-2">
                  <button type="button" 
                    id="submit1"
                    onClick={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                    }}
                  className="btn btn-primary me-2">Submit</button>
                  {/* <Link to="/user_management" className="btn btn-primary me-2">Submit</Link> */}
                </div>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Add_user);
